import { registerNotification } from './registry'

registerNotification('server:restarted', {
  color: (_, theme) => theme.semantic.warning,
  icon:  () => 'reset-circle',
})